import type { Difficulty } from './difficulty';

/** All opponent-skin identifiers. `ai` is the default girl — always owned, free. */
export type SkinId = 'ai' | 'rabbi' | 'punk' | 'dragqueen';

export interface SkinDefinition {
  id: SkinId;
  displayName: string;
  /** Coin cost. 0 means built-in. */
  price: number;
  /** One-line shop description. */
  tagline: string;
  /** Built-in skins are granted on first wallet read. */
  builtIn: boolean;
}

export const SKINS: readonly SkinDefinition[] = [
  {
    id: 'ai',
    displayName: 'Bucket Hat',
    price: 0,
    tagline: 'The classic. Chill vibes.',
    builtIn: true,
  },
  {
    id: 'rabbi',
    displayName: 'The Rabbi',
    price: 800,
    tagline: 'Old-school wisdom, deep drags.',
    builtIn: false,
  },
  {
    id: 'punk',
    displayName: 'Punk Queen',
    price: 1200,
    tagline: 'Studs, mohawk, zero chill.',
    builtIn: false,
  },
  {
    id: 'dragqueen',
    displayName: 'Sparkle Diva',
    price: 2500,
    tagline: 'Eleganza, extravaganza, exhalanza.',
    builtIn: false,
  },
] as const;

export const getSkin = (id: SkinId): SkinDefinition => {
  const s = SKINS.find((x) => x.id === id);
  if (!s) throw new Error(`Unknown skin id: ${id}`);
  return s;
};

// ── Coin rewards ─────────────────────────────────────────────────────────────

interface RewardRule {
  flat: number;
  perSec: number;
}

const REWARD_RULES: Record<Difficulty, RewardRule> = {
  easy:   { flat: 50,  perSec: 2 },
  medium: { flat: 100, perSec: 3 },
  hard:   { flat: 200, perSec: 4 },
  narco:  { flat: 400, perSec: 5 },
};

/** Coins awarded for winning a match. Loss / tie = 0. */
export function computeCoinReward(
  difficulty: Difficulty,
  playerWon: boolean,
  playerTotalSeconds: number,
): number {
  if (!playerWon) return 0;
  const rule = REWARD_RULES[difficulty];
  const safeSecs = Math.max(0, playerTotalSeconds);
  return Math.round(rule.flat + safeSecs * rule.perSec);
}
